import {Component, ElementRef, Input, Renderer2} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'hc-social',
    templateUrl: 'hc-social.html',
    providers: []
})
export class HcSocial {

  //@Input('hpage')   hpage: WebsiteSpotPage;
    @Input('blocked') blocked: any;
    @Input('index') index: number;
    @Input('first') first: boolean;

    @Input('hpage')
    set hpageSet(data: WebsiteSpotPage) {

        this.hpage = data;

        let feedback = this.hpage.rootdata.Hotspots[0].Branded.BrandedBody.Hspot.Feedback;
        this.feedback = (feedback == this.hpage.THotpageFeedback.hfSocial);

    }

    feedback: boolean;
    hpage: WebsiteSpotPage;

    constructor(public element: ElementRef, private renderer: Renderer2) {

        this.renderer.addClass(this.element.nativeElement, 'display-block');

    }

    styleWrap() {

        let style = {};

        let molde = this.hpage.platenode(this.blocked, 'Header', 'Molded', 'Source');
        if (molde) style = {'background': 'url(' + molde + ') no-repeat scroll center center', 'padding': '80px'};

        return style;

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/hc-social/hc-social.ts